import { useRouter } from "next/router";
import SimpleTextBox from "../FormElements/SimpleTextBox"
import { useTranslation } from "next-i18next";
import { useState } from "react";
import { searchArticleHelp } from "services/allServices";
import Link from "next/link";
import { useGlobalStore } from "store/GlobalStore";

const SearchInput = () => {

    const { t } = useTranslation(["help"]);
    const router = useRouter();
    const [setSearchArticleWiki] = useGlobalStore((state) => [state.setSearchArticleWiki]);


    const [searchValue, setSearchValue] = useState('');
    const [searchResult, setSearchResult] = useState([]);

    const handleSearch = async () => {
        if (searchValue.length >= 3) {
            let params = {
                search: searchValue,
                language_id: router.locale === "tr" ? 1 : 2
            }
            await searchArticleHelp(params).then((res) => {
                setSearchResult(res.categories);
            })
        } else {
            setSearchResult([]);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            handleSearch();
        } else if (event.key === "Backspace" && searchValue.length === 0) {
            setSearchResult([]);
        }
    };

    const handleOnChange = (value) => {
        setSearchValue(value);
        if (value.length === 0) {
            setSearchResult([]);
        } else if (value.length >= 3) {
            handleSearch();
        }
    }

    const handleSetSearchArticle = (articles) => {
        setSearchArticleWiki(articles);
    }

    return (
        <div className="">
            <div className="flex pt-8">
                <SimpleTextBox
                    value={searchValue}
                    onChange={handleOnChange}
                    inputName="search"
                    placeholder={t("help:search")}
                    onKeyDown={handleKeyDown}
                    isHelp={true}
                    searchResult={searchResult}
                />
                <button className={`${searchResult.length > 0 ? 'rounded-tr-2xl' : 'rounded-r-2xl'}  h-[39px] mt-6 lg:mt-1 -ml-4 lg:-ml-8 p-4 text-lg flex items-center text-white bg-black`} onClick={() => handleSearch()}>
                    {t("help:search")}< i className="ml-3 text-2xl ri-search-line"></i>
                </button>
            </div>

            {searchResult.length > 0 && (
                <div className="p-4 border-b border-l border-r rounded-b-md bg-gray-50 border-makdosYellow">
                    {searchResult.map((item, index) => (
                        <Link href={`${router.locale === 'tr' ? '/yardim' : '/help'}/${item?.category_slug}/${router.locale === 'tr' ? 'arama' : 'search'}?q=${searchValue}`} key={index}>
                            <div className="p-3 border-b cursor-pointer hover:underline text-textGray hover:text-black" onClick={() => handleSetSearchArticle(item?.articles)}>
                                <p>{item?.category_title} <span>({item?.category_total_count})</span></p>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    )
}

export default SearchInput